module.exports = __webpack_public_path__ + "img/contract.8427f19f.png";